import { render, staticRenderFns } from "./SkeletonTableLead.vue?vue&type=template&id=2b17cea9&scoped=true"
import script from "./SkeletonTableLead.vue?vue&type=script&lang=js"
export * from "./SkeletonTableLead.vue?vue&type=script&lang=js"
import style0 from "./SkeletonTableLead.vue?vue&type=style&index=0&id=2b17cea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17cea9",
  null
  
)

export default component.exports